/* eslint-disable */
import { GetterTree } from "vuex";
import { Skill } from "@/models/skill";
import { Pagination } from "@/models/pagination";
import { RootState } from "@/types";
import { SkillState } from "@/types/skill";

const getters: GetterTree<SkillState, RootState> = {
  list: (state) => {
    return state.pagination ? state.pagination.data : [];
  },
  pagination: (state) => {
    return state.pagination || new Pagination();
  },
  single: (state) => {
    return state.single || new Skill();
  },
  selectItem: (state) => {
    return state.pagination
      ? state.pagination.data.map((skill) => Skill.toSelectItem(skill))
      : [];
  },
  find: (state) => (id: number) => {
    return state.pagination
      ? state.pagination.data.find((skill) => {
          return skill.id == id;
        })
      : new Skill();
  },
};

export default getters;
